'use client'

import { useSyncExternalStore } from 'react'
import { type StoreApi } from 'zustand'
import type { UseBoundStore } from 'zustand'

/**
 * SSR hydration 안전 셀렉터
 * - 서버에서는 fallback 반환, 클라이언트 hydrate 후 실제 값 반환
 * - persist 스토어에서 hydration 불일치 경고 방지
 *
 * @example
 * const items = useHydratedStore(useCartStore, (s) => s.items, [])
 */
export function useHydratedStore<TStore, TSelected>(
  store: UseBoundStore<StoreApi<TStore>>,
  selector: (state: TStore) => TSelected,
  fallback: TSelected
): TSelected {
  return useSyncExternalStore(
    store.subscribe,
    () => selector(store.getState()),
    () => fallback
  )
}
